/**
 * Custom: clean up the "Fabric" / "Composition ...%" line inside each
 * product's description.
 *
 * The raw description HTML (baked into each product from the fabric
 * supplier's catalog data) renders this as two adjacent <span class="term">
 * elements — the first containing just "Fabric" (with a <br> forcing a
 * line break), the second containing "Composition" immediately followed by
 * the percentage breakdown, with no separating space. The exact markup
 * around the percentages varies from product to product (some wrap them in
 * a nested <span>, some don't), so rather than relying on a fragile CSS
 * selector, this walks the actual text content and rebuilds it:
 *
 *   "Fabric Composition" — both words on one line, underlined (see the
 *   `.product__description .term` rule in theme.liquid)
 *   "61% Viscose (Rayon), 39% Cotton" (etc) — on its own line below,
 *   not underlined (see `.product__fabric-composition-rest`)
 */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product__description').forEach(function (description) {
    var terms = description.querySelectorAll('.term');
    if (terms.length < 2) return;

    var fabricEl = terms[0];
    var compositionEl = terms[1];

    // "Fabric" — drop whatever's inside (typically just a trailing <br>)
    // and make sure there's a literal space before "Composition" follows.
    fabricEl.textContent = 'Fabric ';

    // Flatten the composition element's content to plain text so this
    // works whether or not the percentages are wrapped in their own
    // nested span.
    var fullText = compositionEl.textContent.replace(/\s+/g, ' ').trim();
    var spaceIndex = fullText.indexOf(' ');
    if (spaceIndex === -1) return;

    var label = fullText.slice(0, spaceIndex); // "Composition"
    var rest = fullText.slice(spaceIndex + 1).trim(); // "61% Viscose (Rayon), 39% Cotton"

    compositionEl.textContent = label;

    var restEl = document.createElement('span');
    restEl.className = 'product__fabric-composition-rest';
    restEl.textContent = rest;
    compositionEl.insertAdjacentElement('afterend', restEl);
  });
});
